import request from '@/utils/request'

export function getDigitalCollectionPage(params) {
  return request({
    url: '/admin/digital-collection/page',
    method: 'get',
    params
  })
}

export function getDigitalCollectionByUser(userId) {
  return request({
    url: `/admin/digital-collection/user/${userId}`,
    method: 'get'
  })
}

export function getDigitalCollectionDetail(id) {
  return request({
    url: '/admin/digital-collection/detail',
    method: 'get',
    params: { id }
  })
}

export function createDigitalCollection(data) {
  return request({
    url: '/admin/digital-collection',
    method: 'post',
    data
  })
}

export function deleteDigitalCollection(ids) {
  return request({
    url: '/admin/digital-collection',
    method: 'delete',
    data: ids
  })
}
